var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H60C62.2091 0 64 1.79086 64 4V60C64 62.2091 62.2091 64 60 64H4C1.79086 64 0 62.2091 0 60V4Z",
    fill: "#DDDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 54C19.8497 54 10 44.1503 10 32C10 19.8497 19.8497 10 32 10C44.1503 10 54 19.8497 54 32C54 44.1503 44.1503 54 32 54ZM46.799 42.2493C48.8172 39.3406 50 35.8084 50 32C50 22.0589 41.9411 14 32 14C22.0589 14 14 22.0589 14 32C14 35.8084 15.1828 39.3406 17.201 42.2493C19.4519 39.2761 24.7412 38 32 38C39.2588 38 44.5481 39.2761 46.799 42.2493ZM43.9294 45.4795C43.344 43.3747 39.1388 42 32 42C24.8612 42 20.656 43.3747 20.0706 45.4795C23.2466 48.2924 27.4239 50 32 50C36.5761 50 40.7534 48.2924 43.9294 45.4795ZM32 20C27.1582 20 24 23.5115 24 28C24 34.8547 27.5217 38 32 38C36.4362 38 40 34.9592 40 28.4C40 23.8432 36.8284 20 32 20ZM28 28C28 32.5385 29.6364 34 32 34C34.3554 34 36 32.5968 36 28.4C36 25.9008 34.4313 24 32 24C29.4675 24 28 25.6316 28 28Z",
    fill: "#B1B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.483f64d6e1b8d16d2db2bffd611c51d1.svg";
export { ForwardRef as ReactComponent };